import { render, staticRenderFns } from "./RegraDeCalculoForm.vue?vue&type=template&id=151b4f89&scoped=true"
import script from "./RegraDeCalculoForm.vue?vue&type=script&lang=ts"
export * from "./RegraDeCalculoForm.vue?vue&type=script&lang=ts"
import style0 from "./RegraDeCalculoForm.vue?vue&type=style&index=0&id=151b4f89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151b4f89",
  null
  
)

export default component.exports